import { useNavigate } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import { IoArrowBackSharp } from 'react-icons/io5';

import theme from '@styles/theme';

import { FlexBox, TextButton } from '@components/styled/StyledComponents';

type HeadlineProps = {
    DETAIL?: boolean; // 상세 페이지
    TOOLTIP?: boolean;
    GO_BACK?: boolean;
    title: string;
    subTitle?: string;
    fontColor?: string;
    fontSize?: number;
    fontFamily?: string;
    buttonTitle?: string;
    buttonAction?: () => void;
    tooltipText?: string;
};

const Headline = ({
    DETAIL,
    TOOLTIP,
    GO_BACK,
    title,
    subTitle,
    fontColor = theme.colors.positiveBlue,
    fontSize,
    fontFamily,
    buttonTitle,
    buttonAction,
    tooltipText = '미디어 정보에 대한 편집은 여기서 진행해주세요'
}: HeadlineProps) => {
    const navigate = useNavigate();
    return (
        <Wrapper>
            {GO_BACK && (
                <GoBackBtn onClick={() => navigate(-1)}>
                    <IoArrowBackSharp size={24} />
                </GoBackBtn>
            )}
            <FlexBox $justifyContent="space-between">
                <Title>{title}</Title>
                {!subTitle && buttonTitle && (
                    <TextButton
                        onClick={buttonAction}
                        $fontSize={fontSize}
                        $fontFamily={fontFamily}
                        $fontColor={theme.colors.lightGrayFontColor}
                    >
                        {buttonTitle}
                    </TextButton>
                )}
            </FlexBox>

            {subTitle && (
                <FlexBox
                    $justifyContent="space-between"
                    $alignItems="flex-end"
                    $height="auto"
                    $margin="16px  0 0"
                    $position="relative"
                >
                    <SubTitle>{subTitle}</SubTitle>
                    {subTitle && buttonTitle && (
                        <>
                            <Button
                                onClick={buttonAction}
                                $fontColor={fontColor}
                            >
                                {buttonTitle}
                            </Button>
                            {TOOLTIP && <Tooltip>{tooltipText}</Tooltip>}
                        </>
                    )}
                </FlexBox>
            )}
        </Wrapper>
    );
};

export default Headline;

const FadeIn = keyframes`
 from{
    opacity: 0;
  }
  to{
    opacity:1;
  }
`;

const FadeOut = keyframes`
 from{
    opacity: 1;
  }
  to{
    opacity: 0;
  }
`;

const Tooltip = styled.div`
    // css 참고 사이트
    // https://projects.verou.me/bubbly
    position: absolute;
    top: -40px;
    right: -68px;
    padding: 8px;
    background-color: ${theme.colors.positiveBlue};
    color: ${theme.colors.whiteColor};
    font-size: 11px;
    border-radius: 4px;
    z-index: 10;
    opacity: 1;
    animation: ${FadeOut} 0.3s 1.6s forwards;

    &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 0;
        height: 0;
        border: 4px solid transparent;
        border-top-color: ${theme.colors.positiveBlue};
        border-bottom: 0;
        margin-left: -4px;
        margin-bottom: -4px;
    }
`;

const Wrapper = styled.div`
    padding: 80px 0 32px;
    width: 100%;
    height: auto;
`;
const Title = styled.h2<{ $marginBottom?: number }>`
    ${theme.typography.headline1}
    font-family: PretendardBold, sans-serif;
`;

const SubTitle = styled.div`
    ${theme.typography.bodyMobile}
    color: ${theme.colors.deepGrayFontColor};
    font-family: PretendardMedium, sans-serif;
`;
const Button = styled.button<{
    $fontColor?: string;
    $delete?: boolean;
}>`
    padding: 5px 10px;
    font-size: 14px;
    color: ${({ $fontColor }) => $fontColor};
    border: ${({ $fontColor }) => $fontColor} 1px solid;
    border-radius: 4px;
    font-family: PretendardMedium, sans-serif;
    transition: 0.25s;

    &:hover {
        background-color: ${theme.colors.lightGrayHoverColor};
    }

    /* &:hover ~ ${Tooltip} {
        animation: ${FadeIn} 0.3s;
    } */
`;
const GoBackBtn = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0 40px;
`;
